// src/components/DisabledAccount.jsx
import PinchIcon from "./PinchIcon";

export default function DisabledAccount({ displayName, onLogout }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo" style={{ background: "var(--swa-red)" }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
        <div className="auth-title">Pinch Point <PinchIcon /></div>
        <div className="auth-subtitle" style={{ color: "var(--swa-red)" }}>Account Disabled</div>
        <div className="auth-form" style={{ textAlign: "center", gap: "1rem" }}>
          <p style={{ margin: 0, color: "var(--text-dim)", fontSize: "0.95rem", lineHeight: 1.6 }}>
            Hi <strong>{displayName}</strong>, your account has been disabled.
          </p>
          <p style={{ margin: 0, color: "var(--text-dim)", fontSize: "0.95rem", lineHeight: 1.6 }}>
            Please contact your organization's admin for review.
          </p>
          <button className="submit-btn" onClick={onLogout} style={{ marginTop: "0.5rem" }}>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
